<template>
  <v-btn v-bind="props" :to="item.link">{{ item.name }}</v-btn>
</template>

<script>
export default {
  name: 'PageMenuButton',
  props: {
    item: {
      type: Object,
      required: true
    },
    props: {
      type: Object,
      required: true
    }
  }
}
</script>
